import { provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'zone.js';  // Included with Angular CLI.
import { AppModule } from './app.module';
import { GlobalErrorHandler } from './global-error-handler';

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()] })
  .catch(err => new GlobalErrorHandler().handleError(err));
